import { RootState } from '../store';

export const liveStreamSelector = (state: RootState) => state.liveStream;
export const getValueLiveStream = (state: RootState) => state.liveStream.values;
export const loseConnectSelector = (state: RootState) =>
  state.liveStream.loseConnect;
